import Navigation from "../components/Navigation";
import DescriptionSection from "../ui/DescriptionSection";
import FeaturesSection from "../ui/FeaturesSection";
import Footer from "../ui/Footer";
function LandingPage({ tempColor }) {
  return (
    <div>
      <Navigation tempColor={tempColor}></Navigation>
      <DescriptionSection tempColor={tempColor}></DescriptionSection>
      <FeaturesSection tempColor={tempColor}></FeaturesSection>
      <Footer></Footer>
    </div>
  );
}

export default LandingPage;
